import { BaseStore, hookFactory } from '@platform/template';

class Store extends BaseStore {
    constructor(props) {
        super(props);
        this.name = "dragWidthComStore";
    }

    // 数据源
    store = {
        name: '',
        expandFlag: true,
        maxFlag: false,
        tabActiveIndex: 0,
        config: {}, //业务组传进来的config
    };

    /**
     * @description: 钩子
     * @param {type} 
     * @return: 
     */
    getHooks = () => {
        return {
            // 这个是给公共层提供 组件在使用baseComponent 是可以正常运行
            setRef: this.setRef,
            getRef: this.getRef,
            removeRef: this.removeRef,

            // 按路径索引 给内部使用
            getStore: this.getStore.bind(this),
            setStore: this.setStore.bind(this),

            // 数据
            setExpandFlag: this.setExpandFlag.bind(this),
            getExpandFlag: this.getExpandFlag.bind(this),
            setMaxFlag: this.setMaxFlag.bind(this),
            getMaxFlag: this.getMaxFlag.bind(this),
            setTabActiveIndex: this.setTabActiveIndex.bind(this),
            getTabActiveIndex: this.getTabActiveIndex.bind(this),
            setDomWidth: this.setDomWidth.bind(this),
            getDomWidth: this.getDomWidth.bind(this),
        };
    };

    /**
     * @description: 复写
     * @param {type}
     * @return:
     */
    getStore(paths) {
        return super.get(paths);
    }

    /**
     * @description: 复写
     * @param {type}
     * @return:
     */
    setStore(paths, value, shouldForceUpdate = true, callback) {
        let res = super.set(paths, value);
        shouldForceUpdate && this.forceUpdate(callback);
        return res;
    }

    /**
     * @description: 设置展开收起flag
     * @param {expandFlag} 展开收起flag
     * @param {shouldForceUpdate} 是否更新
     * @param {callback} 回调方法
     */
    setExpandFlag({ expandFlag, shouldForceUpdate = true, callback }) {
        this.setStore(["expandFlag"], expandFlag, shouldForceUpdate, callback);
    }

    /**
     * @description: 获取展开收起flag
     */
    getExpandFlag() {
        let expandFlag = this.getStore(["expandFlag"]);
        return expandFlag || false;
    }

    /**
     * @description: 设置最大化flag
     * @param {maxFlag} 最大化flag
     * @param {shouldForceUpdate} 是否更新
     * @param {callback} 回调方法
     */
    setMaxFlag({ maxFlag, shouldForceUpdate = true, callback }) {
        this.setStore(["maxFlag"], maxFlag, shouldForceUpdate, callback);
    }

    /**
     * @description: 获取最大化flag
     */
    getMaxFlag() {
        let maxFlag = this.getStore(["maxFlag"]);
        return maxFlag || false;
    }

    /**
     * @description: 设置当前激活activeIndex
     * @param {tabActiveIndex} 当前激活activeIndex
     * @param {shouldForceUpdate} 是否更新
     * @param {callback} 回调方法
     */
    setTabActiveIndex({ tabActiveIndex, shouldForceUpdate = true, callback }) {
        this.setStore(["tabActiveIndex"], tabActiveIndex, shouldForceUpdate, callback);
    }

    /**
     * @description: 获取当前激活activeIndex
     */
    getTabActiveIndex() {
        let tabActiveIndex = this.getStore(["tabActiveIndex"]);
        return tabActiveIndex || 0;
    }

    /**
     * @description: 设置当前dragWidthCom宽度
     * @param {width} 当前dragWidthCom宽度
     * @param {shouldForceUpdate} 是否更新
     * @param {callback} 回调方法
     */
    setDomWidth({ width, shouldForceUpdate = true, callback }) {
        this.setStore(["domWidth"], width, shouldForceUpdate, callback);
    }

    /**
     * @description: 获取当前dragWidthCom宽度
     */
    getDomWidth() {
        let domWidth = this.getStore(["domWidth"]);
        return domWidth || 0;
    }
}

export default hookFactory(Store);
